import React, { useState, useEffect } from 'react';
import debtorApi from '../../api/debtorApi';
import DebtorHeader from '../../components/debtor/DebtorHeader';
import DebtorStats from '../../components/debtor/DebtorStats';
import DebtorDocumentChart from '../../components/debtor/DebtorDocumentChart';
import DebtorQuickActions from '../../components/debtor/DebtorQuickActions';
import DebtorRecentList from '../../components/debtor/DebtorRecentList';
import { containerVariants, itemVariants } from '../../utils/animations';
import { motion } from 'framer-motion';

export default function DebtorDashboard() {
  const [stats, setStats] = useState({
    totalDebtors: 0,
    activeDebtors: 0,
    completeDocuments: 0,
    incompleteDocuments: 0,
    expiredDocuments: 0,
    totalDocuments: 0,
  });
  const [recentDebtors, setRecentDebtors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      const [statsData, debtorsData] = await Promise.all([
        debtorApi.getStats(),
        debtorApi.getAll(),
      ]);

      const completeCount = debtorsData.filter(d => d.document_status === 'complete').length;
      const incompleteCount = debtorsData.filter(d => d.document_status === 'incomplete').length;

      setStats({
        totalDebtors: statsData.total || 0,
        activeDebtors: statsData.active || 0,
        completeDocuments: completeCount,
        incompleteDocuments: incompleteCount,
        expiredDocuments: 0,
        totalDocuments: debtorsData.length,
      });
      setRecentDebtors(debtorsData.slice(0, 5));
    } catch (error) {
      // Error loading dashboard
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin w-8 h-8 border-4 border-amber-500 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  return (
    <motion.div
      className="space-y-6"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div variants={itemVariants}>
        <DebtorHeader />
      </motion.div>

      <motion.div variants={itemVariants}>
        <DebtorStats stats={stats} />
      </motion.div>

      <div className="grid lg:grid-cols-2 gap-6">
        <motion.div variants={itemVariants}>
          <DebtorDocumentChart stats={stats} />
        </motion.div>
        <motion.div variants={itemVariants}>
          <DebtorQuickActions />
        </motion.div>
      </div>

      <motion.div variants={itemVariants}>
        <DebtorRecentList debtors={recentDebtors} />
      </motion.div>
    </motion.div>
  );
}
